<!-- 💎 Header Section - Breadcrumb y Title -->
<div class="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50/30 p-4 sm:p-6 lg:p-8">
  <div class="max-w-4xl mx-auto">
    
    <!-- 🍞 Breadcrumb Navigation -->
    <nav class="flex mb-6" aria-label="Breadcrumb">
      <ol class="inline-flex items-center space-x-1 md:space-x-3">
        <li class="inline-flex items-center">
          <button 
            (click)="router.navigate(['/config/payment-methods'])"
            class="inline-flex items-center text-sm font-medium text-gray-700 hover:text-blue-600 transition-colors">
            <svg class="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20">
              <path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z"/>
            </svg>
            Configuración
          </button>
        </li>
        <li>
          <div class="flex items-center">
            <svg class="w-6 h-6 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd"/>
            </svg>
            <button 
              (click)="router.navigate(['/config/payment-methods'])"
              class="ml-1 text-sm font-medium text-gray-700 hover:text-blue-600 transition-colors md:ml-2">
              Métodos de Pago
            </button>
          </div>
        </li>
        <li aria-current="page">
          <div class="flex items-center">
            <svg class="w-6 h-6 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd"/>
            </svg>
            <span class="ml-1 text-sm font-medium text-gray-500 md:ml-2">{{ isEditing ? 'Editar' : 'Nuevo' }}</span>
          </div>
        </li>
      </ol>
    </nav>

    <!-- 🎯 Hero Header -->
    <div class="bg-white rounded-2xl shadow-sm border border-gray-100 p-8 mb-8">
      <div class="flex flex-col md:flex-row md:items-center justify-between">
        <div class="flex items-start space-x-4">
          <div class="flex-shrink-0">
            <div class="w-12 h-12 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-xl flex items-center justify-center shadow-lg">
              <svg class="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
                      d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z"/>
              </svg>
            </div>
          </div>
          <div>
            <h1 class="text-3xl font-bold text-gray-900">
              {{ isEditing ? 'Editar Método' : 'Nuevo Método' }}
            </h1>
            <p class="text-gray-600 mt-2">
              {{ isEditing ? 'Modifique la configuración del método de pago seleccionado' : 'Configure un nuevo método de pago para su sistema' }}
            </p>
          </div>
        </div>
        
        <!-- Status Badge (solo cuando está editando) -->
        <div *ngIf="isEditing" class="mt-4 md:mt-0">
          <span class="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
            <svg class="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"/>
            </svg>
            Modo Edición
          </span>
        </div>
      </div>
    </div>

    <!-- Main Form Container -->
    <form [formGroup]="paymentMethodForm" (ngSubmit)="onSubmit()">
      
      <!-- Section 1: Basic Configuration -->
      <div class="bg-white rounded-2xl shadow-sm border border-gray-100 p-8 mb-6 transition-all duration-200 hover:shadow-md">
        <div class="flex items-center space-x-3 mb-6">
          <div class="w-8 h-8 bg-gradient-to-br from-green-500 to-emerald-600 rounded-lg flex items-center justify-center">
            <span class="text-white font-bold text-sm">1</span>
          </div>
          <div>
            <h2 class="text-xl font-semibold text-gray-900">Información Básica</h2>
            <p class="text-gray-600 text-sm">Defina el nombre y tipo del método de pago</p>
          </div>
        </div>

        <div class="grid grid-cols-1 lg:grid-cols-2 gap-8">
          
          <!-- Payment Method Name -->
          <div class="space-y-3">
            <label for="name" class="block text-sm font-semibold text-gray-900" appRequiredLabel>
              <span class="flex items-center">
                <svg class="w-4 h-4 mr-2 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z"/>
                </svg>
                    Nombre del Método de Pago
              </span>
                </label>
            <div class="relative">
                <input
                    type="text"
                    id="name"
                    formControlName="name"
                class="w-full px-4 py-3 border-2 rounded-xl transition-all duration-200 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                [ngClass]="{
                  'border-red-300 bg-red-50': hasError('name', 'required') || hasError('name', 'minlength'),
                  'border-gray-200': !hasError('name', 'required') && !hasError('name', 'minlength'),
                  'border-green-300 bg-green-50': paymentMethodForm.get('name')?.valid && paymentMethodForm.get('name')?.touched
                }"
                placeholder="Ej: PSE, Tarjeta de Crédito, Wompi, PlacetoPay"
              >
              <!-- Success Icon -->
              <div *ngIf="paymentMethodForm.get('name')?.valid && paymentMethodForm.get('name')?.touched" 
                   class="absolute right-3 top-1/2 transform -translate-y-1/2">
                <svg class="w-5 h-5 text-green-500" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"/>
                </svg>
                </div>
            </div>

            <!-- Error Messages -->
            <div *ngIf="hasError('name', 'required')" class="flex items-center text-red-600 text-sm">
              <svg class="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd"/>
              </svg>
              El nombre es obligatorio
            </div>
            <div *ngIf="hasError('name', 'minlength')" class="flex items-center text-red-600 text-sm">
              <svg class="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd"/>
              </svg>
              Mínimo 3 caracteres requeridos
            </div>
          </div>

          <!-- Payment Type Selection -->
          <div class="space-y-3">
            <label class="block text-sm font-semibold text-gray-900" appRequiredLabel>
              <span class="flex items-center">
                <svg class="w-4 h-4 mr-2 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"/>
                </svg>
                Tipo de Procesamiento
              </span>
            </label>
            
            <!-- Custom Radio Button Design -->
            <div class="space-y-3">
              <div class="relative">
                <input type="radio" formControlName="isBankTransfer" [value]="true" id="bankTransfer" 
                       (change)="onBankTransferChange()" class="sr-only peer">
                <label for="bankTransfer" 
                       class="flex items-center p-4 border-2 rounded-xl cursor-pointer transition-all duration-200 peer-checked:border-blue-500 peer-checked:bg-blue-50 hover:bg-gray-50">
                  <div class="flex-shrink-0 w-5 h-5 border-2 rounded-full mr-3 peer-checked:border-blue-500 relative">
                    <div class="w-3 h-3 bg-blue-500 rounded-full absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 hidden peer-checked:block"></div>
                  </div>
                  <div class="flex items-center">
                    <div class="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center mr-3">
                      <svg class="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"/>
                      </svg>
                    </div>
                    <div>
                      <div class="font-medium text-gray-900">Transferencia Bancaria</div>
                      <div class="text-sm text-gray-600">Procesamiento a través de bancos</div>
                    </div>
                  </div>
                </label>
              </div>
              
              <div class="relative">
                <input type="radio" formControlName="isBankTransfer" [value]="false" id="otherMethod" 
                       (change)="onBankTransferChange()" class="sr-only peer">
                <label for="otherMethod" 
                       class="flex items-center p-4 border-2 rounded-xl cursor-pointer transition-all duration-200 peer-checked:border-green-500 peer-checked:bg-green-50 hover:bg-gray-50">
                  <div class="flex-shrink-0 w-5 h-5 border-2 rounded-full mr-3 peer-checked:border-green-500 relative">
                    <div class="w-3 h-3 bg-green-500 rounded-full absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 hidden peer-checked:block"></div>
                  </div>
                  <div class="flex items-center">
                    <div class="w-10 h-10 bg-green-100 rounded-lg flex items-center justify-center mr-3">
                      <svg class="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z"/>
                      </svg>
                    </div>
                    <div>
                      <div class="font-medium text-gray-900">Otros Métodos</div>
                      <div class="text-sm text-gray-600">Efectivo, cheques, pagos directos</div>
                    </div>
                  </div>
                    </label>
                </div>
            </div>
            
            <div *ngIf="hasError('isBankTransfer', 'required')" class="flex items-center text-red-600 text-sm">
              <svg class="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd"/>
              </svg>
              Debe seleccionar el tipo de método
                </div>
            </div>
        </div>

        <!-- 🆕 Default Bank Selection (only visible when isBankTransfer = true) -->
        <div *ngIf="paymentMethodForm.get('isBankTransfer')?.value === true" 
             class="col-span-1 lg:col-span-2 mt-6 p-6 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-xl border-2 border-blue-200">
          <div class="space-y-3">
            <label for="defaultBankId" class="block text-sm font-semibold text-gray-900">
              <span class="flex items-center">
                <svg class="w-4 h-4 mr-2 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"/>
                </svg>
                Banco por Defecto (Opcional)
              </span>
            </label>
            
            <select
              id="defaultBankId"
              formControlName="defaultBankId"
              class="w-full px-4 py-3 border-2 border-blue-200 rounded-xl transition-all duration-200 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white">
              <option [value]="null">Seleccione un banco (opcional)</option>
              <option *ngFor="let bank of banksList" [value]="bank.id">
                {{ bank.bankName }} - {{ bank.accountNumber }}
              </option>
            </select>
            
            <p class="text-xs text-blue-700 flex items-center">
              <svg class="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"/>
              </svg>
              Si este método de pago está asociado a una cuenta bancaria específica, seleccione el banco correspondiente
            </p>
          </div>
        </div>

        <!-- Information Box based on selection -->
        <div class="mt-6" *ngIf="paymentMethodForm.get('isBankTransfer')?.value !== null">
            <div *ngIf="paymentMethodForm.get('isBankTransfer')?.value === true" 
               class="bg-gradient-to-r from-blue-50 to-indigo-50 border-l-4 border-blue-400 p-5 rounded-lg">
            <div class="flex items-start">
                    <div class="flex-shrink-0">
                <svg class="h-6 w-6 text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
                        </svg>
                    </div>
              <div class="ml-3 flex-1">
                <h3 class="text-sm font-medium text-blue-900">Transferencia Bancaria</h3>
                <div class="mt-2 text-sm text-blue-800">
                  <p>Este método requiere validación bancaria y puede estar asociado a cuentas específicas del sistema financiero.</p>
                        </div>
                    </div>
                </div>
            </div>

            <div *ngIf="paymentMethodForm.get('isBankTransfer')?.value === false" 
               class="bg-gradient-to-r from-green-50 to-emerald-50 border-l-4 border-green-400 p-5 rounded-lg">
            <div class="flex items-start">
                    <div class="flex-shrink-0">
                <svg class="h-6 w-6 text-green-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
                        </svg>
                    </div>
              <div class="ml-3 flex-1">
                <h3 class="text-sm font-medium text-green-900">Método Tradicional</h3>
                <div class="mt-2 text-sm text-green-800">
                  <p>Métodos de pago tradicionales como efectivo, cheques, pagos directos o transferencias manuales.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </div>

      <!-- Section 2: Gateway Configuration -->
      <div class="bg-white rounded-2xl shadow-sm border border-gray-100 p-8 mb-8 transition-all duration-200 hover:shadow-md">
        <div class="flex items-center space-x-3 mb-6">
          <div class="w-8 h-8 bg-gradient-to-br from-purple-500 to-indigo-600 rounded-lg flex items-center justify-center">
            <span class="text-white font-bold text-sm">2</span>
          </div>
          <div>
            <h2 class="text-xl font-semibold text-gray-900">Configuración de Pasarela</h2>
            <p class="text-gray-600 text-sm">Configure si este método utiliza una pasarela de pago externa</p>
          </div>
        </div>

        <!-- Gateway Toggle -->
        <div class="mb-6">
          <div class="flex items-start space-x-4 p-5 bg-gradient-to-r from-gray-50 to-slate-50 rounded-xl border border-gray-200">
            <div class="flex-shrink-0">
              <!-- Custom Toggle Switch -->
              <label class="relative inline-flex items-center cursor-pointer">
                <input type="checkbox" formControlName="isPaymentGateway" (change)="onPaymentGatewayChange()" class="sr-only peer">
                <div class="w-14 h-7 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-purple-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[4px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-6 after:w-6 after:transition-all peer-checked:bg-gradient-to-r peer-checked:from-purple-500 peer-checked:to-indigo-600"></div>
              </label>
            </div>
            <div class="flex-1">
              <div class="flex items-center space-x-2 mb-2">
                <h3 class="text-lg font-semibold text-gray-900">Pasarela de Pago</h3>
              </div>
              <p class="text-gray-700 mb-2">Active esta opción si el método procesa pagos a través de una pasarela externa</p>
              <div class="flex flex-wrap gap-2">
                <span class="inline-flex items-center px-2 py-1 text-xs font-medium bg-purple-100 text-purple-800 rounded-full">
                  <span class="w-1.5 h-1.5 bg-purple-500 rounded-full mr-1"></span>
                  Wompi
                </span>
                <span class="inline-flex items-center px-2 py-1 text-xs font-medium bg-blue-100 text-blue-800 rounded-full">
                  <span class="w-1.5 h-1.5 bg-blue-500 rounded-full mr-1"></span>
                  PlacetoPay
                </span>
                <span class="inline-flex items-center px-2 py-1 text-xs font-medium bg-gray-100 text-gray-800 rounded-full">
                  <span class="w-1.5 h-1.5 bg-gray-500 rounded-full mr-1"></span>
                  Otras
                </span>
              </div>
            </div>
          </div>
        </div>

        <!-- Gateway Configuration Fields -->
        <div *ngIf="isPaymentGatewayEnabled" 
             class="ml-4 border-l-4 border-gradient-to-b from-purple-400 to-indigo-500 pl-6 space-y-6">
          
          <!-- Provider Selection -->
          <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div class="space-y-3">
              <label for="gatewayProvider" class="block text-sm font-semibold text-gray-900">
                <span class="flex items-center">
                  <svg class="w-4 h-4 mr-2 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"/>
                  </svg>
                  Proveedor de la Pasarela
                </span>
              </label>
              <select
                id="gatewayProvider"
                formControlName="gatewayProvider"
                class="w-full px-4 py-3 border-2 border-gray-200 rounded-xl transition-all duration-200 focus:ring-2 focus:ring-purple-500 focus:border-purple-500 bg-white">
                <option value="" class="text-gray-500">Seleccione un proveedor</option>
                <option *ngFor="let provider of gatewayProviders" [value]="provider.value" class="py-2">
                  {{provider.label}}
                </option>
              </select>
              <p class="text-xs text-gray-500 flex items-center">
                <svg class="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"/>
                </svg>
                Seleccione el proveedor que procesará los pagos
              </p>
            </div>
          </div>

          <!-- Integration Status -->
          <div class="p-5 bg-gradient-to-br from-indigo-50 to-purple-50 rounded-xl border border-indigo-200">
            <div class="flex items-start space-x-4">
              <div class="flex-shrink-0">
                <!-- Custom Toggle Switch for Integration -->
                <label class="relative inline-flex items-center cursor-pointer">
                  <input type="checkbox" formControlName="isIntegrated" (change)="onIntegratedChange()" class="sr-only peer">
                  <div class="w-12 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-green-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-gradient-to-r peer-checked:from-green-500 peer-checked:to-emerald-600"></div>
                </label>
              </div>
              <div class="flex-1">
                <div class="flex items-center space-x-2 mb-2">
                  <h3 class="text-base font-semibold text-gray-900">Sistema Integrado</h3>
                </div>
                <p class="text-gray-700 text-sm mb-3">Marque si ya existe integración técnica desarrollada con este proveedor</p>
                
                <!-- Status Indicator -->
                <div class="flex items-center space-x-2">
                  <div class="flex items-center space-x-1">
                    <div [ngClass]="paymentMethodForm.get('isIntegrated')?.value ? 'bg-green-500' : 'bg-gray-300'" 
                         class="w-2 h-2 rounded-full transition-colors"></div>
                    <span class="text-xs font-medium" 
                          [ngClass]="paymentMethodForm.get('isIntegrated')?.value ? 'text-green-700' : 'text-gray-500'">
                      {{ paymentMethodForm.get('isIntegrated')?.value ? 'Integrado' : 'Sin integrar' }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Link Generation (only when integrated) -->
          <div *ngIf="isIntegratedFieldsEnabled" 
               class="p-5 bg-gradient-to-br from-orange-50 to-amber-50 rounded-xl border border-orange-200">
            <div class="flex items-start space-x-4">
              <div class="flex-shrink-0">
                <!-- Custom Toggle Switch for Link Generation -->
                <label class="relative inline-flex items-center cursor-pointer">
                  <input type="checkbox" formControlName="requiresLinkGeneration" class="sr-only peer">
                  <div class="w-12 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-orange-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-gradient-to-r peer-checked:from-orange-500 peer-checked:to-amber-600"></div>
                </label>
              </div>
              <div class="flex-1">
                <div class="flex items-center space-x-2 mb-2">
                  <h3 class="text-base font-semibold text-gray-900">Generación de Link</h3>
                </div>
                <p class="text-gray-700 text-sm mb-3">Active si debe generar un link de pago en lugar de un comprobante directo</p>
                
                <!-- Behavior Preview -->
                <div class="text-xs text-gray-600 space-y-1">
                  <div class="flex items-center space-x-2">
                    <div [ngClass]="paymentMethodForm.get('requiresLinkGeneration')?.value ? 'bg-orange-500' : 'bg-blue-500'" 
                         class="w-1.5 h-1.5 rounded-full"></div>
                    <span>
                      {{ paymentMethodForm.get('requiresLinkGeneration')?.value ? 'Genera link de pago → Redirección' : 'Crea comprobante → Proceso directo' }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Configuration Summary -->
          <div class="bg-gradient-to-r from-slate-50 to-gray-50 border-2 border-dashed border-gray-300 rounded-xl p-5">
            <div class="flex items-start space-x-3">
              <div class="flex-shrink-0">
                <svg class="h-6 w-6 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
                </svg>
              </div>
              <div class="flex-1">
                <h4 class="text-sm font-medium text-gray-900 mb-3">Resumen de Comportamiento</h4>
                <div class="text-xs text-gray-700 space-y-2">
                  <div class="flex items-center space-x-2">
                    <span class="w-2 h-2 bg-green-500 rounded-full"></span>
                    <span><strong>Integrado + Genera Link:</strong> Se creará un link de pago automáticamente</span>
                  </div>
                  <div class="flex items-center space-x-2">
                    <span class="w-2 h-2 bg-blue-500 rounded-full"></span>
                    <span><strong>Integrado + NO Genera Link:</strong> Se creará un comprobante de ingreso normal</span>
                  </div>
                  <div class="flex items-center space-x-2">
                    <span class="w-2 h-2 bg-gray-500 rounded-full"></span>
                    <span><strong>NO Integrado:</strong> Se manejará como método de pago convencional</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Action Buttons -->
      <div class="bg-white rounded-2xl shadow-sm border border-gray-100 p-6">
        <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          
          <!-- Form Status -->
          <div class="flex items-center space-x-2 text-sm">
            <div class="flex items-center space-x-1">
              <div [ngClass]="paymentMethodForm.valid ? 'bg-green-500' : 'bg-red-500'" 
                   class="w-2 h-2 rounded-full"></div>
              <span [ngClass]="paymentMethodForm.valid ? 'text-green-700' : 'text-red-700'" class="font-medium">
                {{ paymentMethodForm.valid ? 'Formulario válido' : 'Complete los campos requeridos' }}
              </span>
            </div>
          </div>

          <!-- Buttons -->
          <div class="flex flex-col sm:flex-row gap-3">
            <button
                type="button"
                (click)="router.navigate(['/config/payment-methods'])"
              class="px-6 py-3 border border-gray-300 text-gray-700 rounded-xl hover:bg-gray-50 transition-all duration-200 font-medium flex items-center justify-center space-x-2"
            >
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
              </svg>
              <span>Cancelar</span>
            </button>
            
            <button
                type="submit"
                [disabled]="paymentMethodForm.invalid || submitting"
              class="px-8 py-3 bg-gradient-to-r from-blue-500 to-indigo-600 text-white rounded-xl hover:from-blue-600 hover:to-indigo-700 transition-all duration-200 font-medium shadow-lg hover:shadow-xl disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:shadow-lg flex items-center justify-center space-x-2"
            >
              <!-- Loading Spinner -->
              <svg *ngIf="submitting" class="animate-spin -ml-1 mr-2 h-4 w-4 text-white" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              
              <!-- Success Icon (when valid) -->
              <svg *ngIf="!submitting && paymentMethodForm.valid" class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
              </svg>
              
              <!-- Default Icon -->
              <svg *ngIf="!submitting && !paymentMethodForm.valid" class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-3m-1 4l-3 3m0 0l-3-3m3 3V4"/>
              </svg>
              
              <span>
                {{ submitting ? 'Procesando...' : (isEditing ? '✏️ Actualizar Método' : '✨ Crear Método') }}
              </span>
            </button>
          </div>
        </div>
        </div>
    </form>
  </div>
</div>
